
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CHANGE_LISTENABLE } from '../../../store/actions';
import DatePicker from '@/components/form/DatePicker.vue';
import { ChangeListenable, ConservatorshipDetails } from '../../../types';
import { ApiResponse } from '@/components/types';

const Conservatorship = namespace('conservatorship');

@Component({
  components: {
    DatePicker
  }
})
export default class ListenableDialog extends Vue {
  @Prop({ type: Object, required: true }) conservatorship!: ConservatorshipDetails;
  @Conservatorship.Action(CHANGE_LISTENABLE) changeListenable!: (params: ChangeListenable) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  value: ChangeListenable = {
    conservatorship_id: this.conservatorship.id,
    listenable: !this.conservatorship.conservatee.listenable
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) {
      this.value = {
        conservatorship_id: this.conservatorship.id,
        listenable: !this.conservatorship.conservatee.listenable
      };

      return;
    }

    setTimeout(() => {
      this.error = null;
    }, 200);
  }

  save() {
    this.error = null;

    return this.changeListenable(this.value);
  }
}
